<template>
    <div class="space-y-2">
        <EditableTextField
            text-type="h2"
            :class="[content_text_color_text_class]"
            class="text-xl font-semibold"
            :model-value="translations?.inviteFriendsByEmail || 'Invite friend by email'"
            field-key="inviteFriendsByEmail"
        />
        <EditableTextField
            text-type="p"
            :class="[content_text_color_text_class]"
            class="text-sm opacity-75"
            :model-value="translations?.inviteFriendsByEmailDescription || 'Invite your friends to join by sending them invitation email.'"
            field-key="inviteFriendsByEmailDescription"
        />
    </div>

    <div class="grid grid-cols-5 gap-4 w-full items-start justify-between">
        <div class="lg:col-span-4 col-span-5">
            <input
                :class="[referral_portal_content_layout_corners, 'focus:ring-' + primary_color]"
                class="w-full h-11 min-w-0 flex-auto border-0 px-3.5 py-2.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 bg-white focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
                placeholder="e.g. friend@email.com" id="invite_emails" type="text" name="invite_emails"
                v-model="emails"/>
            <EditableTextField
                text-type="span"
                class="mt-1 block opacity-75 text-sm"
                :class="[content_text_color_text_class]"
                :model-value="translations?.inviteFriendsByEmailNote || 'Additional email addresses must be separated by a comma.'"
                field-key="inviteFriendsByEmailNote"
            />

        </div>
        <div class="lg:col-span-1 col-span-5">
            <a @click='sendInvites'
               :class="[referral_portal_content_layout_corners, 'bg-' + primary_color]"
               class="w-full h-11 flex items-center justify-center gap-1.5 px-3.5 py-2.5 text-sm font-semibold text-white hover:bg-opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">
                <svg class="h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
                        fill="currentColor"></path>
                </svg>
                <EditableTextField
                    v-if="loading"
                    text-type="span"
                    :model-value="translations?.sending || 'Sending'"
                    field-key="sending"
                />
                <EditableTextField
                    v-if="!loading"
                    text-type="span"
                    :model-value="translations?.sendInvite || 'Send invite'"
                    field-key="sendInvite"
                />
            </a>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";
import EditableTextField from "./portal-editable-fields/EditableTextField.vue";

const props = defineProps({
    primaryColor: String,
    contentTextColor: String,
    contentTextColorIsCustom: {type: [Boolean, String, Number], default: false},
    referralPortalContentLayoutCorners: String,
    translations: [null, Object],
});

const emails = ref('');
const loading = ref(false);

const primary_color = props.primaryColor;
const content_text_color = props.contentTextColor;
const content_text_color_is_custom = props.contentTextColorIsCustom;
const referral_portal_content_layout_corners = props.referralPortalContentLayoutCorners;

const content_text_color_text_class = 'text-' + (content_text_color_is_custom ? 'content-custom-text' : content_text_color);

const sendInvites = () => {

    if (loading.value === true || emails.value.trim() === '') {
        return;
    }

    loading.value = true;

    axios.post(route('partners_int.invite_friends'), {emails: emails.value})
        .then((response) => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {
                emails.value = '';
            }
        })
        .finally(() => loading.value = false);

};
</script>
